import React from 'react';
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
} from '@chakra-ui/react';
import { FiMoreVertical } from 'react-icons/fi';
import { isFunction } from 'lodash-es';

const ActionButton = ({ row, rowActions }) => {

  const actionsArray = isFunction(rowActions) ? rowActions(row) : rowActions;

  return (
    <Menu>
      <MenuButton
        as={IconButton}
        aria-label="Actions"
        data-testid={`Actions ${row.index}`}
        icon={<FiMoreVertical />}
        variant="ghost"
      />
      <MenuList zIndex={4}>
        {actionsArray.map(({ label, onClick }, index) => (
          <MenuItem
            key={`action-${row.index}-${index}`}
            data-testid={`${label} ${row.index}`}
            onClick={() => onClick(row)}
          >
            {label}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};

export default ActionButton;
